module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"contestant<% if(isEliminated){ %> eliminated<% } %>\"> <div class=\"item-measure-contents\"> <div> <figure> <% if (model.image.length > 0) { %> <img class=\"contestant-img\" src=\"<%- model.image %>\"> <% } %> </figure> </div> <div class=\"clearfix\"> <div class=\"contestant-wrapper\"> <div class=\"contestant-view\"> <div class=\"name\"><%- model.fullname %></div> </div> <% if(model.secondaryinfo != '') { %> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <% } %> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <% if(!isEliminated){ %> <div class=\"vote\"><%- text.vote_button_copy %></div> <% } else { %> <div class=\"eliminated-vote\"><%- text.eliminated_button_copy %></div> <% } %> </div> </div> </div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="contestant');__stack.lineno=1; if(isEliminated){ ; buf.push(' eliminated');__stack.lineno=1; } ; buf.push('"> <div class="item-measure-contents"> <div> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img class="contestant-img" src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' </figure> </div> <div class="clearfix"> <div class="contestant-wrapper"> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.fullname ), '</div> </div> ');__stack.lineno=1; if(model.secondaryinfo != '') { ; buf.push(' <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> ');__stack.lineno=1; } ; buf.push(' </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> ');__stack.lineno=1; if(!isEliminated){ ; buf.push(' <div class="vote">', (__stack.lineno=1,  text.vote_button_copy ), '</div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated-vote">', (__stack.lineno=1,  text.eliminated_button_copy ), '</div> ');__stack.lineno=1; } ; buf.push(' </div> </div> </div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/vote-option.ejs
// module id = 68
// module chunks = 0